import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { Formik } from "formik";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import Terminal from "terminal-in-react";
import { t } from "ttag";
import { useStoreActions, useStoreState } from "../../models/RootStore";
import AdvancedInputField from "../../widgets/AdvancedInputField/AdvancedInputField";
import SimpleModal from "../../widgets/SimpleModal/SimpleModal";
import NavigationBar from "../NavigationBar/NavigationBar";
import useStyles from "./DeviceManagement.style";
import moment from "moment-timezone";
interface IDevice {
  serial: any;
  pin: any;
  systems: any;
  units: any;
  isConnected: boolean;
  id: string;
  protocolVersion: any;
  itcVersion: any;
  firmwareVersion: any;
  buildDate: any;
  site?: any;
  deviceType?: any;
  disconnectedTimestamp?: any;
}
export default function DeviceManager(props: any) {
  const styles: any = useStyles();
  const upgradeFirmware = useStoreActions((actions) => actions.devices.upgradeFirmware);
  const firmwareStatus = useStoreActions((actions) => actions.devices.firmwareStatus);
  const [error, setError] = useState<any>(null);
  const [shouldBoot, setShouldBoot] = useState<boolean>(false);
  const [showBootAlert, setShowBootAlert] = useState<boolean>(false);
  const [showBootSpinner, setShowBootSpinner] = useState<boolean>(false);
  const [editable, setEditable] = useState<boolean>(false);
  const [device, setDevice] = useState<IDevice>({
    serial: "",
    pin: "",
    systems: "",
    units: "",
    isConnected: false,
    protocolVersion: "protocolVersion",
    itcVersion: "itcVersion",
    firmwareVersion: "firmwareVersion",
    buildDate: "buildDate",
    id: ""
  });
  const [allUnits, setAllUnits] = useState<any>({});
  const [indoorUnits, setIndoorUnits] = useState<any>([]);
  const [outdoorUnits, setOutdoorUnits] = useState<any>([]);
  const [promptColor, setPromptColor] = useState<string>("#f05347");
  const [fmStatus, setFmStatus] = useState<string>("");
  const [fmPercent, setFmPercent] = useState<string>("");
  const [selectedDeviceToDelete, setDeviceToDelete] = useState<any>(null);
  const deleteDevice = useStoreActions((actions) => actions.devices.deleteDevice);
  const deleteSelectedDevice = () => {
    deleteDevice(selectedDeviceToDelete);
    setDeviceToDelete(null);
    props.history.push(`/devices`);
  };
  let checkStatus = true;
  const getSiteName = useStoreState((state) => state.sites.getSiteName);
  const deviceTypes = useStoreState((state) => state.types.deviceTypes);

  const getDevice = useStoreActions((actions) => actions.devices.getDeviceById);
  const controlDevice = useStoreActions(
    (actions) => actions.devices.controlDevice
  );

  const getAllUnits = useStoreActions((actions) => actions.units.getAllUnits);
  const { dateFormat, timeFormat } = useStoreState((state) => state.users);
  

  const {
    match: {
      params: { deviceId }
    }
  } = props;

  // Called when entering the component.
  const checkStatusFMFc = async (device: any) => {
    const status = await firmwareStatus(device.id);

    // do nothing when no status
    if (!status.data || (status.data && status.data.status === "")) {
      setFmStatus("");
      return;
    }

    const statusToShow = status.data.status !== "UPDATING" ? status.data.status : `${status.data.status}...`;
    setFmStatus(statusToShow);
    setFmPercent(
      status.data.percent != null && status.data.percent !== ""
        ? `${status.data.percent}% complete`
        : ""
    );
    if (status.data.status !== "UPDATED") {
      checkStatusFM(device);
    }
  };

  // Using the state to clean the last timeout that is running
  const [checkStatusFM, setCheckStatusFM] = useState<any>(() => (deviceData: any) => setTimeout(async () => {
    // If already in the timeout, but exited the screen - don't do anything
    if (!checkStatus) {
      return;
    }
    const status = await firmwareStatus(deviceData.id);
    const statusToShow = status.data.status !== "UPDATING" ? status.data.status : `${status.data.status}...`;
    setFmStatus(statusToShow);
    setFmPercent(
      status.data.percent != null && status.data.percent !== ""
        ? `${status.data.percent}% complete`
        : ""
    );

    // As long as not UPDATED - will continue on checking status
    if (status.data.status !== "UPDATED") {
      checkStatusFM(deviceData);
    } else {
      setTimeout(() => {
        setFmStatus("");
      }, 23 * 1000);
    }
  }, 3000));

  useEffect(() => {
    if (!deviceId) {
      return;
    }

    getAllUnits().then((allunits: any) => {
      setAllUnits(allunits);
    });
    getDevice(deviceId).then((res: any) => {
      setDevice(res);
      //Check if UPDATING when entering component
      checkStatusFMFc(res);
    });

    // Stop the query of FM update status when leaving component
    return () => {
      checkStatus = false;
      setCheckStatusFM(null);
    };

  }, [deviceId]);

  useEffect(() => {
    if (_.isEmpty(device) || _.isEmpty(allUnits)) {
      return;
    }
    const { units } = device;
    let indoorUnits: any = [];
    let outdoorUnits: any = [];

    const filterUnits =
      units &&
      units.filter((unitId: any) => {
        const unit = allUnits[unitId];
        if (unit) {
          if (unit.type === 1) {
            return indoorUnits.push(unit);
          } else {
            return outdoorUnits.push(unit);
          }
        }
      });
    setIndoorUnits(indoorUnits);
    setOutdoorUnits(outdoorUnits);
  }, [device, allUnits]);

  const onFileLoad = (event: any) => {
    if (event.target) {
      const file = event.target.files[0];
      const data = new FormData();
      data.append("file", file);

      upgradeFirmware({ deviceId: device.id, command: data });
      setFmStatus("Starting...");
      checkStatusFM(device);

      event.target.value = "";

    } else {
      console.log("something went wrong while loading the file", event);
    }
  };

  const { serial, systems, isConnected, protocolVersion, itcVersion, firmwareVersion, buildDate, deviceType, disconnectedTimestamp } = device;
  return (
    <NavigationBar
      navTitle={t`Device Management`}
      pageTitle={t`Device Management`}
      {...props}
    >

      <div className={styles.editDeviceWrapper}>
        <SimpleModal
          showModal={!!error}
          title={t`Error had happened`}
          contentText={error ? error : ""}
          actionName={t`OK`}
          onAction={() => {
            setError(null);
          }}
          closeModal={() => {
            setError(null);
          }}
        />

        <SimpleModal
          showModal={showBootAlert}
          title={t`Missing Boot alert`}
          contentText={t`Changes will not be set without booting the device. Are you sure you want to leave?`}
          actionName={t`Leave`}
          onAction={() => {
            props.onClose();
          }}
          closeModal={() => {
            setShowBootAlert(false);
          }}
        />
        <SimpleModal
          showModal={showBootSpinner}
          title={t`Booting, please wait...`}
          actionName={t`OK`}
          onAction={_.noop}
          closeModal={_.noop}
          hideBtns={true}
        >
          <div className={styles.bootWrapper}>
            <CircularProgress />
          </div>
        </SimpleModal>

        {!_.isEmpty(device) && (
          <Paper className={styles.section}>
            {shouldBoot && (
              <Typography
                className={styles.bootTitle}
              >{t`Boot device required`}</Typography>
            )}

            <Formik
              initialValues={{
                serialNumber: serial,
                deviceType: deviceType ? deviceTypes[deviceType]?.name : "CA Device",
                connectionStatus: isConnected.toString(),
                protocolVersion: itcVersion ?? protocolVersion,
                firmwareVersion,
                indoorUnits: indoorUnits.length.toString(),
                outdoorUnits: outdoorUnits.length.toString(),
                numOfSystems: systems.length,
                buildDate,
                disconnectedTimestamp: disconnectedTimestamp ? moment(disconnectedTimestamp).format(`${dateFormat} ${timeFormat}`) : ""
              }}
              enableReinitialize={true}
              onSubmit={() => { }}
            >
              {(props) => {
                return (
                  <form className={styles.siteDetailsForm}>
                    <Typography
                      className={styles.deviceInfoTitle}
                    >{t`Device Information`}
                      <IconButton
                        onClick={() => {
                          setDeviceToDelete(device.id);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Typography>

                    <AdvancedInputField
                      name="serialNumber"
                      label={t`serial number`}
                      editable={editable}
                      {...props}
                    />
                    <AdvancedInputField
                      name="deviceType"
                      label={t`device type`}
                      editable={editable}
                      {...props}
                    />
                    <AdvancedInputField
                      name="connectionStatus"
                      label={t`connection status`}
                      editable={editable}
                      {...props}
                    />
                    <AdvancedInputField
                      name="protocolVersion"
                      label={t`protocol version`}
                      editable={editable}
                      {...props}
                    />
                    {firmwareVersion && (
                      <AdvancedInputField
                        name="firmwareVersion"
                        label={t`firmware version`}
                        editable={editable}
                        {...props}
                      />
                    )}

                    <AdvancedInputField
                      name="indoorUnits"
                      label={t`indoor units`}
                      editable={editable}
                      {...props}
                    />
                    <AdvancedInputField
                      name="outdoorUnits"
                      label={t`outdoor units`}
                      editable={editable}
                      {...props}
                    />
                    <AdvancedInputField
                      name="numOfSystems"
                      label={t`number of systems`}
                      editable={editable}
                      {...props}
                    />
                     {disconnectedTimestamp && (
                      <AdvancedInputField
                        name="disconnectedTimestamp"
                        label={t`Disconnected Date`}
                        editable={false}
                        {...props}
                      />
                    )}
                    {buildDate && (
                      <AdvancedInputField
                        name="buildDate"
                        label={t`build date`}
                        editable={editable}
                        {...props}
                      />
                    )}
                    <div className={styles.addButtonContainer}>
                      <Button
                        className={styles.buttonStyle}
                        variant="contained"
                        component="label"
                      >
                        {t`Upload firmware update`}
                        <input
                          onChange={onFileLoad}
                          type="file"
                          style={{ display: "none" }}
                        />
                      </Button>
                    </div>
                    {fmStatus &&
                      <div>
                        <Typography
                          className={styles.deviceInfoTitle}
                        >{fmStatus}
                        </Typography>
                        <Typography>{fmPercent}</Typography>
                      </div>}
                  </form>
                );
              }}
            </Formik>

            <Grid className={styles.consoleContainer}>
              {(protocolVersion >= 1 || itcVersion >= 0)  && isConnected && (
                <Terminal
                  startState="maximised"
                  color="#f05347"
                  outputColor="white"
                  prompt={promptColor}
                  backgroundColor="black"
                  barColor="black"
                  style={{
                    maxHeight: "100%",
                    fontSize: "1.125em",
                    width: "100%"

                  }}
                  commands={{
                    help: (cmd: any, print: any) => {
                      setPromptColor("black");
                      const command = { command: cmd.slice(0).join(" ") };
                      controlDevice({ deviceId, command })
                        .then((res: any) => {
                          print(res);
                          setPromptColor("#f05347");
                        })
                        .catch((err: any) => {

                          if (!_.isString(err)) {
                            err = JSON.stringify(err);
                          }

                          print(err);
                          setPromptColor("#f05347");
                        });
                    }
                  }}
                  commandPassThrough={(cmd: any, print: any) => {
                    setPromptColor("black");
                    const command = { command: cmd.slice(0).join(" ") };
                    controlDevice({ deviceId, command })
                      .then((res: any) => {
                        print(res);
                        setPromptColor("#f05347");
                      })
                      .catch((err: any) => {

                        if (!_.isString(err)) {
                          err = JSON.stringify(err);
                        }

                        print(err);
                        setPromptColor("#f05347");
                      });
                  }}
                  msg="DEVICE CONTROL"
                  allowTabs={false}
                  showActions={false}
                />
              )}
            </Grid>
          </Paper>
        )
        }
      </div>
      <SimpleModal
        showModal={!!selectedDeviceToDelete}
        title={t`Are you sure?`}
        contentText={device.site ? t`Are you sure you want to delete device` + ` ${device.serial} ` + t`in site ` + `${getSiteName(device.site)}` + ` ?` :
          t`Are you sure you want to delete device ` + `${device.serial} ?`}
        actionName={t`OK`}
        onAction={deleteSelectedDevice}
        closeModal={() => setDeviceToDelete(null)}
      />
    </NavigationBar>
  );
}
